import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Observable } from 'rxjs/internal/Observable';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerHolidayBusinessService } from '../../../business-services/dealer-holiday.service';
import { Constant } from './../../../../../../Autofacets-Core/src/app/utils/constant';
import { DealerHolidaySaveViewModel, DealerHolidayViewModel } from './../../../business-entities/dealer-holiday-list-view-model';
import { TranslateService } from '@ngx-translate/core';
import { AdminCommonService } from '../../../services/admin-common.service';

@Component({
    selector: 'app-edit-dealer-holiday',
    templateUrl: './edit-dealer-holiday.component.html'
})


export class EditDealerHolidayComponent implements OnInit {

    dealerSelected: string;
    dealerList: SelectListItemViewModel[];
    selectedDealerId: string;
    dealerHolidayId: number = 0;
    isValidDate = true;
    curentYear: number = new Date().getFullYear();
    addDealerHolidayForm: FormGroup;
    dealerHolidayViewModel: DealerHolidayViewModel;
    dealerHolidaySaveViewModel: DealerHolidaySaveViewModel;
    constructor(
        private adminCommonService :AdminCommonService,
        private formBuilder: FormBuilder,
        private dealerHolidayBusinessService: DealerHolidayBusinessService,
        private toastr: ToastrService,
        private spinner: NgxSpinnerService,
        private activeModal : NgbActiveModal,
        private translate: TranslateService
    ) { }

    ngOnInit(): void {
        this.dealerHolidayId = this.dealerHolidayBusinessService.dealerHolidayId;
        this.dealerHolidayBusinessService.isEdit = true;
        this.initializeModel();
        this.getDealerHolidayDetails(this.dealerHolidayId);
        this.addDealerHolidayForm = this.formBuilder.group({
            dealer: ['', [Validators.required]],
            name: ['', [Validators.required]],
            startDate: [''],
            endDate: ['']
        });


    }

    initializeModel() {
        this.dealerHolidayViewModel = {
            id: 0,
            dealerId: '0',
            name: '',
            dealerName: '',
            startDate: '',
            endDate: '',
            dealerList: [],
            dmsHolidayId: ''
        };
    }

    async getDealerHolidayDetails(
        dealerHolidayId: number) {
        this.spinner.show();
        await this.dealerHolidayBusinessService.getDealerHolidayDetails(dealerHolidayId).then((response) => {
            this.dealerHolidayViewModel = response;
            this.dealerList = this.dealerHolidayBusinessService.dealerList;
            this.selectedDealerId = this.dealerHolidayViewModel.dealerId;
            this.dealerSelected = this.dealerList.filter(x => (x.value === this.dealerHolidayViewModel.dealerId) ? x.text : '')[0].text;
            this.spinner.hide();
        });
    }

    get cpf() {
        return this.addDealerHolidayForm.controls;
    }

    formatter = (result: SelectListItemViewModel) => result.text.toUpperCase();

    search = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => {
                return term === '' ? []
                    : this.dealerList.filter(v => v.text.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
            })
        )

   
    setDealer(event: NgbTypeaheadSelectItemEvent) {
        event.preventDefault();
        this.selectedDealerId = event.item.value;
        this.dealerSelected = event.item.text;
    }

    onSubmit(): void {
        if (this.addDealerHolidayForm.invalid) {
            return;
        }

        const temp = new Date();
        let endDate = new Date(Utility.getDateStringToDate(this.addDealerHolidayForm.value.endDate).getTime() - (temp.getTimezoneOffset() * 60000));
        let startDate = new Date(Utility.getDateStringToDate(this.addDealerHolidayForm.value.startDate).getTime() - (temp.getTimezoneOffset() * 60000));
       this.dealerHolidaySaveViewModel=
        {
            id: this.dealerHolidayId,
            dealerId: this.selectedDealerId,
            name: this.addDealerHolidayForm.value.name,
            dealerName: this.addDealerHolidayForm.value.dealerName,
            startDate: startDate,
            endDate: endDate,
            dealerList: [{value:this.selectedDealerId,text:this.dealerSelected}],
            dmsHolidayId: this.dealerHolidayViewModel.dmsHolidayId
        }

        //Date validation
       if (this.validateDateTime(startDate,endDate)) {
            this.dealerHolidayBusinessService.editDealerHolidays(this.dealerHolidaySaveViewModel).then((response) => {
                if (response.responseCode === Constant.SuccessResponseCode) {
                    if(response.responseObject.isValid == 1 && response.responseObject.name != null){
                        let errorMsg = this.translate.instant('lblHolidayNotAdded') +' ' + response.responseObject.name.replace(/^,/, '');
                        this.toastr.error(errorMsg);
                    }
                    else if(response.responseObject.isValid == 0 && response.responseObject.name != null){
                        let errorMsg = this.translate.instant('lblPlanningPresent') +' ' + response.responseObject.name.replace(/^,/, '');
                        this.toastr.error(errorMsg);
                    }
                    else{
                        this.toastr.success(Constant.SuccessfullyAdded);
                        this.activeModal.close({ success: true });
                    }
                }
            });
        }
    }

    convertDate(d: any) {
        let parts = d.split(" ");
        let months = { Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06", Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12" };
        return parts[3] + "-" + months[parts[1]] + "-" + parts[2];
    }

    validateDates(sDate: string, eDate: string) {
        if (sDate == null || eDate == null) {
            this.toastr.error(Constant.DateValidation);
            return !this.isValidDate;
        }

        if (eDate < sDate) {
            this.toastr.error(Constant.DateRangeValidation);
            return !this.isValidDate;
        }
        return this.isValidDate;
    }

    validateDateTime(startDate:Date,endDate:Date)
    {
        if(endDate<startDate)
        {
            this.toastr.error(Constant.DateRangeValidation);
            return !this.isValidDate;
        }
        return this.isValidDate;
    }
    OnClose(){
        this.activeModal.dismiss('Cross click')
    }

}
